import { CheckCircleIcon } from "@heroicons/react/20/solid";
import cleanDeep from "clean-deep";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import apiURL from "../../../store/actions/apiURL";
import { Actions as COMPANYACTIONS } from "../../../store/actions/companyActions";
import { Actions as LEAVEACTIONS } from "../../../store/actions/leaveActions";
import LoadingContent from "../../common/LoadingContent";
import Spinner from "../../common/Spinner";
import UpgradeRequired from "../../company-pages/UpgradeRequired";
import Rule from "./Rule";

const TimeAndAttendanceSettings = ({
	currentOrg,
	updateCompanyDetails,
	organisationDetails,
	updateSetting,
	allowanceOvertimeOptions,
	isDemo,
	getLeaveTypes,
	disabled,
	includedInPlan,
}) => {
	useEffect(() => {
		getLeaveTypes();
	}, []);

	const { handleSubmit, control, register, watch } = useForm();


	const onSubmit = (data) => {
		if (saving) return;

		updateCompanyDetails(
			cleanDeep(
				{ org: String(currentOrg), ...data },
				{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
			),
		);

		setSaving(true);
		fetch(apiURL + "/settings/timesheet-rules", {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(rules),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// obtained data
				setSaving(false);
				console.log("saved settings", data);
			});
	};

	const [rules, setRules] = useState([]);

	const [loaded, setLoaded] = useState(false);
	const [settings, setSettings] = useState(false);
	const [saving, setSaving] = useState(false);

	useEffect(() => {
		console.log("starting to obtain Data");

		if (!loaded) {
			// set loaded right away to avoid a re-trigger

			const paths = ["/settings/timesheet-rules"];

			Promise.all(
				paths.map(
					(path) =>
						fetch(apiURL + path, {
							// fetch('http://localhost:3000/report/templates' , {
							credentials: "include",
							method: "GET",
							headers: {
								"Accept": "application/json",
								"Content-Type": "application/json",
							},
						}).then((response) => response.json()),
					// .catch(logError)
				),
			).then((data) => {
				// do something with the data
				console.log("data recieved", data);

				setLoaded(true);

				setRules(data[0].rules || []);
			});
		}
	}, []);

	if (!loaded) return <LoadingContent />;

	const updateRule = (rule) => {
		const newRules = [...rules];

		const ruleIndex = _.findIndex(newRules, { id: rule.id });

		if (ruleIndex !== -1) {
			newRules[ruleIndex] = rule;
		} else {
			newRules.push(rule);
		}

		setRules(newRules);
	};

	const rulesWithBlank = [
		...rules,
		{
			id: rules.length,
			rules: { parts: [{}] },
		},
	];
	if (!includedInPlan && !isDemo) return <UpgradeRequired />;

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="px-8">
			<div
				className="col-xs-12 form-section"
				style={{ paddingBottom: "2rem" }}
			>
				<div className="col-xs-12 form-container">
					<div className="pull-left">
						<h4>Time &amp; Attendance Rules</h4>
						<p style={{ margin: 0 }}>
							Create rules below in order of precendence. Last rule that matches will be considered the
							most important one.
						</p>
					</div>
				</div>
				{rulesWithBlank.map((rule, index) => (
					<Rule
						key={rule.id}
						index={index}
						rule={rule}
						selectOptions={allowanceOvertimeOptions}
						updateRule={updateRule}
					/>
				))}
				<div className="clearfix" />
			</div>
			{!disabled && (
				<button
					type="submit"
					className="btn btn-success pull-right"
				>
					{saving ? (
						<Spinner
							style={{ height: "1.5em", float: "left", marginRight: 10 }}
							className="animate-spin -ml-1 mr-3 h-5 w-5 "
						/>
					) : (
						<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 10 }} />
					)}
					<span>Save</span>
				</button>
			)}

			<div className="clearfix" />
		</form>
	);
};

const mapStateToProps = (state) => {
	const allowanceOvertimeOptions = [];

	state.company?.settings?.overtimes?.map((o) => {
		allowanceOvertimeOptions.push({
			value: o.id,
			label: o.name,
		});
	});
	state.company?.settings?.allowances?.map((o) => {
		allowanceOvertimeOptions.push({
			value: o.id,
			label: o.name,
		});
	});

	const leaveTypes = state.leave?.leaveTypes?.map((o) => {
		return {
			value: o.id,
			label: o.name,
		};
	});

	return {
		currentOrg: state.company?.settings?.org,
		allowanceOvertimeOptions,
		allowances: state.company?.settings?.allowances,
		overtime: state.company?.settings?.overtimes,
		departments: state.company?.settings?.departments,
		leaveTypes: leaveTypes,
		isDemo: state.company?.settings?.isDemo,
		organisationDetails: state.company?.settings,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		jurisdiction: state.company?.settings?.jurisdiction,
		includedInPlan: state.permissions?.plan?.timesheets,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateSetting: (field, newValue) => dispatch(COMPANYACTIONS.updateSetting(field, newValue, false)),
	updateCompanyDetails: (body) => dispatch(COMPANYACTIONS.updateCompanyDetails(body)),
	getLeaveTypes: () => dispatch(LEAVEACTIONS.getLeaveTypes()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimeAndAttendanceSettings);
